// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"67":"8d1cb062","95":"ef063719","179":"9f8e1652","362":"41e5a3a7","765":"ca62ec22","795":"d4001185"}[chunkId] + ".css";
};